/*
 * O banner de boas-vindas: título grande, a mensagem de boas-vindas
 * do admin e um campo de busca em pílula, sobre o fundo tingido da página.
 *
 * Herda do Hero do core para manter a classe `.Hero` — o IndexPage mede a
 * altura dela para devolver o leitor ao mesmo ponto da lista.
 */
import app from 'flarum/forum/app';
import Hero from 'flarum/forum/components/Hero';
import GlobalSearch from 'flarum/forum/components/GlobalSearch';
import ItemList from 'flarum/common/utils/ItemList';
import { forumBool } from '../utils/settings';
export default class WelcomeBanner extends Hero {
  className() {
    return 'CanelaWelcome';
  }
  bodyItems() {
    const items = new ItemList();
    const title = app.forum.attribute('welcomeTitle')?.trim() || app.forum.attribute('title');
    const message = app.forum.attribute('welcomeMessage')?.trim();
    items.add('text', m("div", {
      className: "CanelaWelcome-text"
    }, m("h1", {
      className: "CanelaWelcome-title"
    }, title), message ? m("div", {
      className: "CanelaWelcome-message"
    }, m.trust(message)) : null), 100);
    if (forumBool('canelaWelcomeBannerSearch', true)) {
      items.add('search', m("div", {
        className: "CanelaWelcome-search"
      }, m(GlobalSearch, {
        state: app.search.state
      })), 50);
    }
    return items;
  }
}
flarum.reg.add('ramon-canela', 'forum/list/WelcomeBanner', WelcomeBanner);